'use strict';

{
    var app = angular.module('tf.services', [])

        .service('helperService', function () {
            this.toBool = function (val) {
                if (val == 'undefined' || val == null || val == '' || val == 'false' || val == 'False')
                    return false;
                else if (val == true || val == 'true' || val == 'True')
                    return true;
                else
                    return 'unidentified';
            };
            this.shuffle = function (array) {
                var currentIndex = array.length, temp, randomIndex;

                while (0 !== currentIndex) {
                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex -= 1;

                    temp = array[currentIndex];
                    array[currentIndex] = array[randomIndex];
                    array[randomIndex] = temp;
                }
                return array;
            }
            this.extend = function (out) {
                out = out || {};

                for (var i = 1; i < arguments.length; i++) {
                    if (!arguments[i])
                        continue;

                    for (var key in arguments[i]) {
                        if (arguments[i].hasOwnProperty(key))
                            out[key] = arguments[i][key];
                    }
                }
                return out;
            };
        })

        .service('sessionExpiredService', ['$uibModal', 'userConfig', "$window", function($uibModal, userConfig, $window) {
            var isOpen = false;
            var isOt = userConfig.branding === 'OPEN_TRADER';
             var source = $window.location.hash.substring(3);
             var url = "";
             if (source) {
                 url += "?redirectSource=" + encodeURI(source);
             }
             var host = $window.location.host;
             if (host.indexOf("liquidity") !== -1) {
                 $window.location.href = "/tradefloor/oauth2/authorization/liquidity" + url;
             }else if (host.indexOf("bellmont") !== -1) {
                //  $window.location.href = "/login" ;
                 $window.location.href = "/tradefloor/oauth2/authorization/bellmont";
             }else if (host.indexOf("future-assist") !== -1) {
                //  $window.location.href = "/login" ;
                 $window.location.href = "/tradefloor/oauth2/authorization/future_assist";
             }else if (host.indexOf("iinvest") !== -1) {
                //  $window.location.href = "/login" ;
                 $window.location.href = "/tradefloor/oauth2/authorization/iinvest";
             }else if (host.indexOf("allfin") !== -1) {
                //  $window.location.href = "/login" ;
                 $window.location.href = "/tradefloor/oauth2/authorization/allfin";
             }else if (host.indexOf("waimak") !== -1) {
                //  $window.location.href = "/login" ;
                 $window.location.href = "/tradefloor/oauth2/authorization/waimak";
             }else if (host.indexOf("tradefloor.com.au") !== -1) {
                //  $window.location.href = "/login" ;
                 $window.location.href = "/tradefloor/oauth2/authorization/tf";
             }else if (host.indexOf("openmarkets.com.au") !== -1) {
                //  $window.location.href = "/login" ;
                 $window.location.href = "/tradefloor/oauth2/authorization/om";
             }else{
                $window.location.href = "/#/signin" + url;
             }

//            return {
//                openDialog : function() {
//                    if (isOpen) {
//                        return;
//                    }
//
//                    isOpen = true;
//                    var loggedOutMesage = '<p style="line-height: 22px;" translate="common.LOGGED_OUT_MESSAGE"></p>\n';
//
//                    if(isOt === true) {
//                        loggedOutMesage = '<p style="line-height: 22px;" translate="common.LOGGED_OUT_MESSAGE_OT"></p>\n';
//                    }
//
//                    var sessionErrorTemplate = '<div class="animated bounceIn" style="padding:20px; text-align: center; line-height: 40px;">\n' +
//                        ' <i style="font-size: 60px;" class="icon-circle-cross text-danger"></i><br>\n' +
//                        loggedOutMesage +
//                        '<button class="btn btn-primary" ng-click="ok()" translate="common.LOGIN"></button></div>';
//                    var modalInstance = $uibModal.open({
//                        template: sessionErrorTemplate,
//                        controller: 'SessionErrorCtrl',
//                        size : 'sm',
//                        backdrop : 'static',
//                        keyboard : false
//                    }).result.finally(function() {
//                        isOpen = false;
//                    });
//                }
//            };
        }])

        .service('tfStore', ['$uibModal', '$rootScope',
            function($uibModal, $rootScope) {
                return {
                    open: function (attrs, opts) {
                        // Create a new scope so we can pass custom
                        // variables into the splash modal
                        var scope = $rootScope.$new();
                        angular.extend(scope, attrs);
                        opts = angular.extend(opts || {}, {
                            backdrop: true,
                            scope: scope,
                            templateUrl: 'app/layout/store/storeTC.tpl.html',
                            controller: 'storeCtrl',
                            windowTemplateUrl: 'app/layout/store/layout.tpl.html'
                        });
                        return $uibModal.open(opts);

                    }

                };
            }
        ])

        .constant('confirmationTypes', {
            clearStrategy : {name : 'clearStrategy', title : 'confirm.TITLE_CLEAR_STRATEGY', message : 'confirm.MESSAGE_CLEAR_STRATEGY', skippable: true, okText: 'confirm.ACTION_DELETE_ALL' },
            deleteAllStrategies : {name : 'deleteAllStrategies', title : 'confirm.TITLE_DELETE_ALL_STRATEGIES', message : 'confirm.MESSAGE_DELETE_ALL_STRATEGIES', skippable: true, okText: 'confirm.ACTION_DELETE_ALL' },
            cancelOrder : {name : 'cancelOrder', title : 'confirm.TITLE_CANCEL_ORDER', message : 'confirm.MESSAGE_CANCEL_ORDER', skippable: true, okText: 'confirm.ACTION_CANCEL_ORDER' },
            deletePost : {name : 'deletePost', title : 'confirm.TITLE_DELETE_POST', message : 'confirm.MESSAGE_DELETE_POST', skippable: true,okText: 'confirm.ACTION_DELETE' },
            deleteStudy: { name: "deleteStudy", title: "confirm.TITLE_DELETE_STUDY", message : "confirm.MESSAGE_DELETE_STUDY", skippable: true, okText: 'confirm.ACTION_DELETE' },
            deleteDrawing: { name: "deleteDrawing", title: "confirm.TITLE_REMOVE_DRAWING", message: "confirm.MESSAGE_REMOVE_DRAWING", skippable: true, okText: 'confirm.ACTION_DELETE' },
            saveOrderChanges: { name: "saveOrderChanges", title: "confirm.TITLE_SAVE_ORDER_CHANGES", message: "confirm.MESSAGE_SAVE_ORDER_CHANGES", skippable: false , okText: 'confirm.ACTION_SAVE', cancelText: 'confirm.ACTION_DISCARD'},
            clearBackTestingTrades: { name: "clearBackTestingTrades", title: "confirm.TITLE_CLEAR_SIMULATION", message: "confirm.MESSAGE_CLEAR_SIMULATION", skippable: true },
            deleteSecurityAlert: { name: "deleteSecurityAlert", title: "confirm.TITLE_DELETE_PRICE_ALERT", message: "confirm.MESSAGE_DELETE_PRICE_ALERT", skippable: true, okText: 'confirm.ACTION_DELETE'},
            deleteWatchlist: { name: "deleteWatchlist", title: "confirm.TITLE_DELETE_WATCHLIST", message: "confirm.MESSAGE_DELETE_WATCHLIST", skippable: true, okText: 'confirm.ACTION_DELETE'},
            deleteDashboard: { name: "deleteDashboard", title: "confirm.TITLE_DELETE_DASHBOARD", message: "confirm.MESSAGE_DELETE_DASHBOARD", skippable: true, okText: 'confirm.ACTION_DELETE'},
            resetAccount: { name: "resetAccount", title: "confirm.TITLE_RESET_YOUR_ACCOUNT", message: "confirm.MESSAGE_RESET_YOUR_ACCOUNT", skippable: false, okText: 'confirm.ACTION_RESET'},
            replaceChartTemplates: { name: "replaceChartTemplates", title: "confirm.TITLE_REPLACE_TEMPLATE", message: "confirm.MESSAGE_REPLACE_TEMPLATE", skippable: true},
            deleteChartTemplate: { name: "deleteChartTemplate", title: "confirm.TITLE_DELETE_TEMPLATE", message: "confirm.MESSAGE_DELETE_TEMPLATE", skippable: true, okText: 'confirm.ACTION_DELETE'}
        })
        .service('confirmationService', ['$uibModal', '$rootScope', '$localStorage', '$q', 'confirmationTypes',
            function($uibModal, $rootScope, $localStorage, $q, confirmationTypes) {

                var confirmationSettings = $localStorage.$default({
                    doNotShow : {}
                });

                return {
                    shouldNotShow: function(confirmationType) {
                        var shouldNotShow = confirmationSettings.doNotShow[confirmationType.name];
                        if (shouldNotShow === undefined) {
                            shouldNotShow = false;
                        }

                        return $q.when(shouldNotShow);
                    },
                    doNotShow : function(confirmationType, doNotShow) {
                        if (doNotShow === undefined) {
                            doNotShow = true;
                        }

                        if (doNotShow) {
                            confirmationSettings.doNotShow[confirmationType.name] = doNotShow;
                        } else {
                            confirmationSettings.doNotShow[confirmationType.name] = undefined;
                        }
                    },
                    confirmationSettings : function() {
                        return Object.keys(confirmationTypes).map(function (confirmationTypeName) {
                            var confirmationType = confirmationTypes[confirmationTypeName];
                            var shouldNotShow = confirmationSettings.doNotShow[confirmationType.name];
                            if (shouldNotShow === undefined) {
                                shouldNotShow = false;
                            }

                            return {
                                confirmationType : confirmationType,
                                show : !shouldNotShow
                            }
                        });
                    },
                    confirm: function (confirmationType, message) {

                        if (typeof confirmationType === "string") {
                            confirmationType = confirmationTypes[confirmationType]
                        }

                        var self = this;
                        return self.shouldNotShow(confirmationType).then(function (shouldNotShow) {
                            if (shouldNotShow) {
                                return true;
                            }

                            var scope = $rootScope.$new();
                            scope.message = message || confirmationType.message;
                            scope.title = confirmationType.title;
                            scope.skippable = confirmationType.skippable;
                            scope.okText = confirmationType.okText || 'confirm.ACTION_YES';
                            scope.cancelText = confirmationType.cancelText || 'confirm.ACTION_NO';
                            scope.data = {
                                shouldNotShow : false
                            };

                            var opts = {
                                backdrop: true,
                                scope: scope,
                                templateUrl: 'app/layout/confirmationService/confirmationService.tpl.html'
                            };
                            return $uibModal.open(opts).result.finally(function () {
                                if (scope.data.shouldNotShow) {
                                    self.doNotShow(confirmationType);
                                }
                            });
                        });
                    },
                    // A Generic function that does not track the "Do Not Show" feature
                    open: function (message, title) {
                        const scope = $rootScope.$new();
                        scope.message = message;
                        scope.title = title || "confirm.CONFIRM";
                        scope.okText = 'confirm.ACTION_YES';
                        scope.cancelText = 'confirm.ACTION_NO';
                        scope.skippable = false;
                        scope.data = {
                            shouldNotShow: false
                        };
                        const opts = {
                            backdrop: true,
                            scope: scope,
                            templateUrl: 'app/layout/confirmationService/confirmationService.tpl.html'
                        };
                        return $uibModal.open(opts).result;
                    }
                };
            }
        ])

        .service('photoUpload', ['$uibModal', '$rootScope',
            function($uibModal, $rootScope) {
                var isOpen = false;
                return {
                    open: function () {
                        if (isOpen) {
                            return;
                        }

                        isOpen = true;

                        var scope = $rootScope.$new();
                        var opts = {
                            backdrop: true,
                            scope: scope,
                            templateUrl: 'app/layout/photoUpload/photoUpload.tpl.html',
                            controller: 'photoUploadCtrl'
                            //windowTemplateUrl: 'app/layout/confirmationService/layout.tpl.html'

                        };
                        return $uibModal.open(opts).result.finally(function() {
                            isOpen = false;
                        });
                    }
                }
            }])

        .service('Map', function($q) {

            var tradefloorOffice = new google.maps.LatLng(-33.8630052, 151.2105843);
            //var mapMarker = 'images/beachflag.png';

            this.init = function() {
                var options = {
                    center: new google.maps.LatLng(-33.866429, 151.2105843),
                    zoom: 14,
                    disableDefaultUI: false,
                    scrollwheel: false,
                    navigationControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    scaleControl: true,
                    draggable: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_CENTER
                    },
                    styles:
                        [
                            {
                                "featureType": "administrative",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "lightness": 33
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "color": "#f2e5d4"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#c5dac6"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "lightness": 20
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "lightness": 20
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#c5c6c6"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#e4d7c6"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#fbfaf7"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#acbcc9"
                                    }
                                ]
                            }
                        ]
                };
                this.map = new google.maps.Map(
                    document.getElementById("map-canvas"), options
                );

                this.marker = new google.maps.Marker({
                    position: tradefloorOffice,
                    map: this.map,
                    title: 'Level 2, 50 Bridge Street, Sydney'
                    //icon: mapMarker
                });
                //this.places = new google.maps.places.PlacesService(this.map);
            }


        })

        .service('gameLoss', ['$uibModal', '$rootScope', function($uibModal, $rootScope) {
            var alreadyShown = false;
            return {
                open: function (attrs, opts) {
                    if (alreadyShown) {
                        return;
                    }

                    alreadyShown = true;
                    // Create a new scope so we can pass custom
                    // variables into the splash modal
                    var scope = $rootScope.$new();
                    angular.extend(scope, attrs);
                    opts = angular.extend(opts || {}, {
                        backdrop: true,
                        scope: scope,
                        templateUrl: 'app/layout/gamePopups/youLose.tpl.html',
                        controller: 'gamePopupsCtrl'
                        //windowTemplateUrl: 'app/layout/confirmationService/layout.tpl.html'

                    });
                    return $uibModal.open(opts);

                }

            };
        }
        ])

        .service('upgradeBrowser', ['$uibModal', '$rootScope', function($uibModal, $rootScope) {
            var alreadyShown = false;
            return {
                open: function (attrs, opts) {
                    if (alreadyShown) {
                        return;
                    }

                    alreadyShown = true;
                    // Create a new scope so we can pass custom
                    // variables into the splash modal
                    var scope = $rootScope.$new();
                    angular.extend(scope, attrs);
                    opts = angular.extend(opts || {}, {
                        size : 'lg',
                        backdrop: true,
                        scope: scope,
                        templateUrl: 'app/layout/popups/upgradeBrowser.tpl.html',
                        controller: 'upgradeBrowserCtrl',
                        resolve : {
                            reason : function() {
                                return attrs.reason;
                            }
                        }
                        //windowTemplateUrl: 'app/layout/confirmationService/layout.tpl.html'

                    });
                    return $uibModal.open(opts);

                }

            };
        }
        ])

//END STORE

}
